import {l} from "types/typescriptdefinisjoner_lederplan";
import angular, {resource} from "angular";
import {RessursFeilhåndtering} from "../RessursFeilhåndtering";
import {gettextCatalog} from "angular-gettext";
import _ from "lodash";
import {regNavn} from "../tredjepartsTjenestenavn";
import {Debugger} from "debug";
import IResourceArray = ng.resource.IResourceArray;

const debug: Debugger = require('debug')('GruppeInvitasjonRessurs');

//extender ikke BasisRessurs da vi pga opplasting av avtar har spesialhåndtering
export class GruppeInvitasjonRessurs {

    static regNavn = 'GruppeInvitasjonRessurs';

    static forInjisering() {
        return [
            regNavn.ng.$resource,
            RessursFeilhåndtering.regNavn,
            regNavn.gettext.gettextCatalog,
            GruppeInvitasjonRessurs
        ]
    }

    constructor(private $resource: ng.resource.IResourceService,
                private ressursFeilhåndtering: RessursFeilhåndtering,
                private gettextCatalog: gettextCatalog) {
        this.ressurs = $resource<l.GruppeInvitasjonModell>(
            '/api/gruppeinvitasjon/:medlemId', {medlemId: '@medlemId'}, {
                kanSlettes: {method: 'GET', url: '/api/gruppeinvitasjon/:medlemId/kanSlettes', params: {medlemId: '@medlemId'}},
                slettEllerAnonymiser: {method: 'POST', url: '/api/gruppeinvitasjon/:medlemId/slettEllerAnonymiser', params: {medlemId: '@medlemId'}},
                innviterNyttMedlem: {method: 'PUT', url: '/api/gruppeinvitasjon', params: {medlemId: ''}},
                innviterNyeMedlemmer: {method: 'PUT', url: '/api/gruppeinvitasjon/invitasjoner', params: {medlemId: ''}},
                godtaInvitasjonTilNyBruker: {method: 'PUT', url: '/api/gruppeinvitasjon/:medlemId/godtaInvitasjonTilNyBruker'},
                godtaInvitasjonTilNyBrukerFraSubject: {method: 'PUT', url: '/api/gruppeinvitasjon/:medlemId/godtaInvitasjonTilNyBrukerFraSubject'},
                godtaInvitasjonFraTokenSomEksisterendeBruker: {method: 'PUT', url: '/api/gruppeinvitasjon/:token/godtaInvitasjonFraTokenSomEksisterendeBruker', params: {token: '@token'}},
                godtaInvitasjonSomEksisterendeBruker: {method: 'PUT', url: '/api/gruppeinvitasjon/:medlemId/godtaInvitasjonSomEksisterendeBruker', params: {medlemId: '@medlemId'}},
                avslåInvitasjonSomEksisterendeBruker: {method: 'PUT', url: '/api/gruppeinvitasjon/:medlemId/avslaaInvitasjonSomEksisterendeBruker', params: {medlemId: '@medlemId'}},
                sendInvitasjon: {method: 'POST', url: '/api/gruppeinvitasjon/sendInvitasjon/:medlemId'},
                finnInvitasjonerTilGrupper: {method: 'GET', url: '/api/gruppeinvitasjon/finnInvitasjonerTilGrupper', params: {gruppeId: ''}, isArray: true},
                finnInvitasjonerTilGodkjenning: {method: 'GET', url: '/api/gruppeinvitasjon/finnInvitasjonerTilGodkjenning', isArray: true},
                finnInvitasjon: {method: 'GET', url: '/api/gruppeinvitasjon/finnInvitasjon/:token', params: {token: '@token', medlemId: '@medlemId'}},
                sendOtp: {method: 'POST', url: '/api/gruppeinvitasjon/sendOtp/:token', params: {token: '@token'}},
                sendOtpTilInnloggetBruker: {method: 'POST', url: '/api/gruppeinvitasjon/:medlemId/sendOtpTilInnloggetBruker', params: {medlemId: '@medlemId'}},
                validerOtp: {method: 'POST', url: '/api/gruppeinvitasjon/validerOtp/:token', params: {token: '@token'}}
            }
        );
    }

    private ressurs: ng.resource.IResourceClass<l.GruppeInvitasjonModell>;


    kanSlettes(medlemId: string): l.KanSlettesModell {
        debug('kanSlettes', medlemId);
        return this.ressurs['kanSlettes'](
            {medlemId: medlemId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke slette gruppeinvitasjon'))
        );
    }

    slett(medlemId: string, vedOk: () => void = _.noop) {
        debug('slett', medlemId);
        return this.ressurs.delete(
            {medlemId: medlemId},
            vedOk,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke slette gruppeinvitasjon'))
        );
    }

    slettEllerAnonymiser(medlemId: string, årsak: string): l.InvitasjonSlettetRespons {
        debug('slettEllerAnonymiser', medlemId);
        return this.ressurs['slettEllerAnonymiser'](
          {medlemId: medlemId, aarsak: årsak},
          _.noop,
          this.håndterFeil(() => this.gettextCatalog.getString('Kunne ikke slette gruppeinvitasjon'))
        );
    }

    innviterNyttMedlem(spesifikasjon: l.OpprettGruppeInvitasjonSpesifikasjon): l.GruppeInvitasjonModell {
        debug('innviterNyttMedlem', angular.toJson(spesifikasjon));
        return this.ressurs['innviterNyttMedlem'](
            spesifikasjon,
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke opprette ny gruppeinvitasjon')));
    }

    innviterNyeMedlemmer(spesifikasjoner: l.GruppeInvitasjonSpesifikasjoner): l.GruppeModell {
        debug('innviterNyeMedlemmer', angular.toJson(spesifikasjoner));
        return this.ressurs['innviterNyeMedlemmer'](
            spesifikasjoner,
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke opprette nye gruppeinvitasjoner')));
    }

    godtaInvitasjonTilNyBruker(spesifikasjon: l.GodtaInvitasjonTilNyBrukerSpesifikasjon): l.GruppeMedlemModell {
        return this.ressurs['godtaInvitasjonTilNyBruker'](
            spesifikasjon,
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke godta invitasjon'))
        );
    }

    godtaInvitasjonSomEksisterendeBruker(medlemId: string, engangskode?: string): l.GruppeInvitasjonTilGodkjenningModell {
        debug('godtaInvitasjonSomEksisterendeBruker', medlemId);
        return this.ressurs['godtaInvitasjonSomEksisterendeBruker'](
            {medlemId: medlemId, engangskode: engangskode},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke godta invitasjon'))
        );
    }

    godtaInvitasjonFraTokenSomEksisterendeBruker(token: string, engangskode?: string): l.OkRespons {
        debug('godtaInvitasjonFraTokenSomEksisterendeBruker', token);
        return this.ressurs['godtaInvitasjonFraTokenSomEksisterendeBruker'](
            {token: token, engangskode: engangskode},
            _.noop,
            this.håndterFeil(() => this.gettextCatalog.getString('Kunne ikke godta invitasjon'))
        );
    }

    godtaInvitasjonTilNyBrukerFraSubject(spesifikasjon:l.GodtaInvitasjonTilNyBrukerFraOpenidSubjectSpesifikasjon): l.OkRespons {
        debug('godtaInvitasjonTilNyBrukerFraSubject', spesifikasjon);
        return this.ressurs['godtaInvitasjonTilNyBrukerFraSubject'](
            spesifikasjon,
            _.noop,
            this.håndterFeil(() => this.gettextCatalog.getString('Kunne ikke godta invitasjon'))
        );
    }

    avslåInvitasjonSomEksisterendeBruker(medlemId: string): l.OkRespons {
        debug('avslåInvitasjonSomEksisterendeBruker', medlemId);
        return this.ressurs['avslåInvitasjonSomEksisterendeBruker'](
            {medlemId: medlemId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke avslå invitasjon'))
        );
    }

    sendInvitasjon(medlemId: string, vedOk: () => void = _.noop) {
        debug('sendInvitasjon', medlemId);
        return this.ressurs['sendInvitasjon'](
            {medlemId: medlemId},
            vedOk,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke sende invitasjon ' + medlemId))
        );
    }

    finnInvitasjonerTilGodkjenning(): IResourceArray<l.GruppeInvitasjonTilGodkjenningModell> {
        debug('finnInvitasjonerTilGodkjenning');
        return this.ressurs['finnInvitasjonerTilGodkjenning'](
            {},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke finne invitasjoner til grupper'))
        );
    }

    finnInvitasjon(token: string, medlemId: string, vedFeil: (feil: resource.IResourceResponse) => boolean = () => false): l.GruppeInvitasjonStatusModell {
        debug('finnInvitasjon', token);
        return this.ressurs['finnInvitasjon'](
            {token: token, medlemId: medlemId},
            _.noop,
            this.håndterFeil(() => this.gettextCatalog.getString('Kunne ikke finne invitasjon'), vedFeil)
        );
    }

    sendOtp(token: string): l.InvitasjonOtpSendtModell {
        debug('sendOtp', token);
        return this.ressurs['sendOtp'](
            {token: token},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke sende engangskode'))
        );
    }

    sendOtpTilInnloggetBruker(medlemId: string): l.InvitasjonOtpSendtModell {
        debug('sendOtpTilInnloggetBruker', medlemId);
        return this.ressurs['sendOtpTilInnloggetBruker'](
            {medlemId: medlemId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke sende engangskode'))
        );
    }

    validerOtp(token: string, engangskode: string): l.GruppeInvitasjonTilGodkjenningModell {
        debug('validerOtp', token);
        return this.ressurs['validerOtp'](
            {token: token, engangskode: engangskode},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke validere engangskode'))
        );
    }

    //hjelpemetoder

    håndterFeil(melding: () => string,
                eksternHåndtering: (feil: resource.IResourceResponse) => boolean = () => false): (feil: resource.IResourceResponse) => void {
        return this.ressursFeilhåndtering.håndterRequestFeil(melding, null, eksternHåndtering);
    }
}
